/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncomingChatMessage } from './IncomingChatMessage';
import {
    IncomingChatMessageFromJSON,
    IncomingChatMessageFromJSONTyped,
    IncomingChatMessageToJSON,
    IncomingChatMessageToJSONTyped,
} from './IncomingChatMessage';

/**
 * 
 * @export
 * @interface ChatPayload
 */
export interface ChatPayload {
    /**
     * 
     * @type {string}
     * @memberof ChatPayload
     */
    id?: string;
    /**
     * 
     * @type {Array<IncomingChatMessage>}
     * @memberof ChatPayload
     */
    messages?: Array<IncomingChatMessage>;
}

/**
 * Check if a given object implements the ChatPayload interface.
 */
export function instanceOfChatPayload(value: object): value is ChatPayload {
    return true;
}

export function ChatPayloadFromJSON(json: any): ChatPayload {
    return ChatPayloadFromJSONTyped(json, false);
}

export function ChatPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'messages': json['messages'] == null ? undefined : ((json['messages'] as Array<any>).map(IncomingChatMessageFromJSON)),
    };
}

export function ChatPayloadToJSON(json: any): ChatPayload {
    return ChatPayloadToJSONTyped(json, false);
}

export function ChatPayloadToJSONTyped(value?: ChatPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messages': value['messages'] == null ? undefined : ((value['messages'] as Array<any>).map(IncomingChatMessageToJSON)),
    };
}

